import styles from './Text.module.css'

export function TextMain({ children }) {
    return (
        <p className={styles.main}>
            {children}
        </p>
    )
}

export function TextDescription({ children, small, color, bold }) {
    if (small) {
        return (
            <p className={styles.small}>
                {children}
            </p>
        )
    }
    if (bold || color) {
        return (
            <p className={styles.description} style={{ color, fontWeight: 'bold' }}>
                {children}
            </p>
        )
    }
    return (
        <p className={styles.description}>
            {children}
        </p>
    )
}

export function TextError({ children }) {
    return (
        <div className={styles['error-container']}>
            <p className={styles.error}>
                {children}
            </p>
        </div >
    )
}